import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  useContext,
} from 'react';
import { AppIcon } from '@common';
import {
  crossIcon,
  filterIcon2,
  filterLayersIcon,
  plusIcon,
} from '@src/assets/svg';
import MainFilters from './components/MainFilters';

import { FiltersContext } from './context/filters-context';
import iconFilter from '../../../assets/icons/icons8-filter-16.png';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import './style.scss';

const DashboardFilters = (props) => {
  const { state, dispatch, date } = useContext(FiltersContext);

  const ref = useRef(null);
  const [dropdown, setDropdown] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);
  const [tooltipContent, setTooltipContent] = useState('');

  useEffect(() => {
    const handler = (event) => {
      if (dropdown && ref.current && !ref.current.contains(event.target)) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const toggleDropDown = useCallback(
    () => setDropdown((oldState) => !oldState),
    []
  );

  const depthLevel = 1;
  function formatObject(inputObj) {
    const formattedKey = inputObj.title.toUpperCase(); // Convert title to uppercase
    const selectedList = inputObj.selectedList;

    // Extract the key-value pairs from the selectedList
    const formattedList = Object.entries(selectedList).map(([name, _id]) => ({
      _id,
      name,
    }));

    // Return the object in the desired format
    return {
      [formattedKey]: formattedList,
    };
  }

  useEffect(() => {
    let resultForParent = {};
    state.forEach((state) => {
      resultForParent = { ...resultForParent, ...formatObject(state) };
    });

    props?.setFilters(resultForParent);

    const selectedList = state[0]?.selectedList || state[1]?.selectedList || {};

    setIsFiltered(selectedList);
  }, [
    ...state.flatMap((item) => Object.entries(item.selectedList).length),
    date.dateState,
  ]);

  useEffect(() => {
    console.log('Full state:', state);

    const tooltipArray = state.map((list) => {
      console.log('Processing List:', list); // Log each list item

      if (!list.selectedList) {
        console.log('❌ Missing selectedList for:', list.title);
        return ''; // Handle cases where selectedList is undefined
      }

      let extractedValue =
        list.title === 'Date'
          ? Object.values(list.selectedList).join(', ')
          : Object.keys(list.selectedList).join(', ');

      console.log(`Extracted Value for "${list.title}":`, extractedValue);
      return extractedValue;
    });

    const filteredTooltip = tooltipArray.filter(
      (content) => content.trim() !== ''
    ); // Remove empty values
    console.log('Filtered Tooltip:', filteredTooltip);

    const finalTooltip = filteredTooltip.join(' | ');
    console.log('Final Tooltip:', finalTooltip);
    setTooltipContent((prev) => {
      console.log('Previous Tooltip:', prev);
      console.log('New Tooltip:', finalTooltip);
      return finalTooltip;
    });
  }, [state]);
  useEffect(() => {
    dispatch[0]({ type: 'REMOVE_SELECTED' });
  }, []);

  return (
    <div
      className={props?.id === 'filters-1' ? 'dashboardFilters' : ''}
      ref={ref}
    >
      {props?.id == 'filters-1' && (
        <div className="dashboardFilters--showcase--title">
          <AppIcon icon={filterLayersIcon} />
          <span>Filters</span>
        </div>
      )}

      <div className="dashboardFilters--showcase--selectedFilters">
        {state.map((list, index) => {
          const valuesCount = 0;

          return Object.entries(list.selectedList).length > 0
            ? props?.id == 'filters-1' && (
                <div
                  key={index}
                  className={`dashboardFilters--showcase--selectedFilters--item ${
                    valuesCount > 3 ? 'overflow' : ''
                  }`}
                >
                  <span className="dashboardFilters--showcase--selectedFilters--item--key">
                    {list.title}:
                  </span>
                  <span className="dashboardFilters--showcase--selectedFilters--item--value">
                    {list.title === 'Date'
                      ? Object.values(list.selectedList || {}).join(',')
                      : Object.keys(list.selectedList || {}).join(',')}
                  </span>
                  <AppIcon
                    icon={crossIcon}
                    onClick={() => {
                      if (list.title === 'Date') {
                        date.removeDate();
                      } else {
                        dispatch[index]({ type: 'REMOVE_SELECTED' });
                      }
                    }}
                    className="dashboardFilters--showcase--selectedFilters--item--icon"
                  />
                </div>
              )
            : null;
        })}
        <div
          className="dashboardFilters--dropdown"
          onMouseEnter={() => setTooltipContent(tooltipContent)}
          onMouseLeave={() => setTooltipContent('')}
        >
          {props?.id == 'filters-1' ? (
            <button
              aria-expanded={dropdown.toString()}
              onClick={toggleDropDown}
              className="dashboardFilters--dropdown--toggle"
            >
              <AppIcon icon={plusIcon} className="pl-1" />
              <span className="dashboardFilters--dropdown--toggle--text pr-1">
                Add Filter
              </span>
            </button>
          ) : (
            <>
              <button
                aria-expanded={dropdown.toString()}
                onClick={toggleDropDown}
                onMouseEnter={() => setTooltipContent(tooltipContent)}
                onMouseLeave={() => setTooltipContent('')}
                className="dashboardFilters--dropdown--toggle relative"
                data-tip="Click to add a filter"
                data-for="filter-tooltip"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.29327 15.1004C6.97327 15.1004 6.65993 15.0204 6.3666 14.8604C5.77993 14.5337 5.4266 13.9404 5.4266 13.2737V9.74039C5.4266 9.40706 5.2066 8.90706 4.99993 8.65372L2.5066 6.01372C2.0866 5.59372 1.7666 4.87372 1.7666 4.33372V2.80039C1.7666 1.73372 2.57327 0.900391 3.59993 0.900391H12.3999C13.4133 0.900391 14.2333 1.72039 14.2333 2.73372V4.20039C14.2333 4.90039 13.8133 5.69372 13.4199 6.08706L10.5333 8.64039C10.2533 8.87372 10.0333 9.38706 10.0333 9.80039V12.6671C10.0333 13.2604 9.65993 13.9471 9.19327 14.2271L8.27327 14.8204C7.97327 15.0071 7.63327 15.1004 7.29327 15.1004ZM3.59993 1.90039C3.13327 1.90039 2.7666 2.29372 2.7666 2.80039V4.33372C2.7666 4.58039 2.9666 5.06039 3.21993 5.31372L5.75994 7.98706C6.09994 8.40706 6.43327 9.10706 6.43327 9.73372V13.2671C6.43327 13.7004 6.73327 13.9137 6.85993 13.9804C7.13994 14.1337 7.47993 14.1337 7.73993 13.9737L8.6666 13.3804C8.85327 13.2671 9.03994 12.9071 9.03994 12.6671V9.80039C9.03994 9.08706 9.3866 8.30039 9.8866 7.88039L12.7399 5.35372C12.9666 5.12706 13.2399 4.58706 13.2399 4.19372V2.73372C13.2399 2.27372 12.8666 1.90039 12.4066 1.90039H3.59993Z"
                    fill="#CDD0D5"
                  />
                  <path
                    d="M4.00044 7.16749C3.9071 7.16749 3.82044 7.14083 3.73377 7.09416C3.50044 6.94749 3.4271 6.63416 3.57377 6.40083L6.86044 1.13416C7.0071 0.900827 7.31377 0.827493 7.5471 0.97416C7.78044 1.12083 7.85377 1.42749 7.7071 1.66083L4.42044 6.92749C4.3271 7.08083 4.1671 7.16749 4.00044 7.16749Z"
                    fill="#CDD0D5"
                  />
                </svg>
                {/* Small red dot when filter is applied */}
                {Object.keys(isFiltered).length > 0 && (
                  <span
                    className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"
                    onMouseEnter={() => setTooltipContent(tooltipContent)}
                    onMouseLeave={() => setTooltipContent('')}
                    data-tip={tooltipContent} // Use tooltipContent here
                    data-for="filter-tooltip"
                  ></span>
                )}
              </button>
              <ReactTooltip id="filter-tooltip" place="top" effect="solid">
                {tooltipContent}
              </ReactTooltip>
              {tooltipContent && (
                <div className="absolute top-4 right-1 bg-black text-white text-xs px-2 py-1 rounded shadow-md whitespace-nowrap">
                  {tooltipContent}
                </div>
              )}
            </>
          )}

          <MainFilters
            dropdown={dropdown}
            depthLevel={depthLevel}
            toggleDropDown={toggleDropDown}
            handleDateSelection={date.handleDateSelection}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardFilters;
